module.exports = __webpack_public_path__ + "img/user-7.926674d5.svg";